import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export async function setScheduledTask(task) {
    return mutate(
        gql`
            mutation SetScheduledTask($task: JSONObject!) {
                setScheduledTask(task: $task)
            }
        `,
        { task },
        { returns: "setScheduledTask" }
    )
}
